const changeRoute = (route, handleUpdateRouteState) => {
    handleUpdateRouteState({
      data : route
    })
  }

  export default changeRoute;